<script>
export default {
    props: {
        media: Object,
        allowRename: Boolean,
        url: String,
    },
    data() {
        return {
            filename: this.media.filenameWithoutExtension,
        }
    },
    methods: {
        submit() {
            axios.put(this.url, {
                filename: this.filename,
            }).then((response) => {
                let media = _.merge(this.media, response.data);

                this.$emit('renamed', media);

                this.$refs.closeBtn.click();
            }).catch((error) => {
                toastr.error(error, 'Could not rename file', {timeOut: 5000});
                console.log(error);
            });
        }
    },
    computed: {
        id() {
            return `media-rename-${this.media.id}`;
        }
    }
}
</script>

<template>
    <dd>{{ media.filename }}
        <Lightbox
            :id="id"
            :headline="__('scoop-os.media.rename_file')"
            class="inline"
            v-if="allowRename"
        >
            <tooltip slot="open-template" position="right" :text="__('scoop-os.media.rename_file')">
                <button class="btn btn-primary btn-xs m-l-xs"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            </tooltip>
            <div slot="body">
                <div class="form-group">
                    <input type="text" class="form-control" v-model="filename" @keydown.enter="submit">
                </div>
            </div>
            <div v-cloak slot="footer">
                <button class="btn btn-white" data-dismiss="modal" v-text="__('scoop-os.common.close')"
                        ref="closeBtn"></button>
                <button type="button" class="btn btn-primary" v-text="__('scoop-os.common.save')"
                        @click="submit"></button>
            </div>
        </Lightbox>
    </dd>
</template>
